import FarmEquipment from '@assets/images/landing-page/products/farm-equipment-finance.png';
import HomeLoan from '@assets/images/landing-page/products/home-loan.png';
import LoanAgainstProperty from '@assets/images/landing-page/products/loan-against-property.png';
import MicroLoan from '@assets/images/landing-page/products/micro-loan.png';
import PersonalLoan from '@assets/images/landing-page/products/personal-loan.png';
import SMELoan from '@assets/images/landing-page/products/sme-loan.png';
import TwoWheeler from '@assets/images/landing-page/products/two-wheeler-finance.png';
import { DatatableColumnProps, FunnelItemType, TierObject } from '@utils/types';

export const productCards = [
  {
    name: 'Two-Wheeler Finance',
    description:
      'Get Two-Wheeler Loans at competitive rates with up to 4 years of repayment tenure and a simple documentation process.',
    image: TwoWheeler,
    link: '',
  },
  {
    name: 'Home Loan',
    description:
      'Buy your own home with our flexible Housing Loan options. Get competitive interest rates and up to 25-years long repayment tenure in a few easy application steps.',
    image: HomeLoan,
    link: '',
  },
  {
    name: 'Loan Against Property',
    description:
      'Unlock the potential of your property with an L&T Finance Loan Against Property. Avail a loan ranging upto ₹7.5 Cr. with a tenure of upto 15 years & fund disbursal within 72 hrs. Interest rate starts at 9.60%* p.a.',
    image: LoanAgainstProperty,
    link: '',
  },
  {
    name: 'Personal Loan',
    description:
      "Our online Personal Loans of up to ₹15 Lakhs fit your unique needs, whether it's a vacation, a home improvement project, or unexpected medical bills.",
    image: PersonalLoan,
    link: '',
  },
  {
    name: 'SME Loan',
    description:
      'Own your entrepreneurial vision SME Loans. Our flexible loan options provide the financial support you need to grow, innovate, and achieve your goals.',
    image: SMELoan,
    link: '',
  },
  {
    name: 'Farm Equipment Finance',
    description:
      'Financing farm equipment is now easier with our agriculture loan options. We offer agriculture loan schemes for new tractors across all manufacturers, providing flexible and customised loan offerings based on land holdings. With a maximum loan tenure of up to 72 months, you can easily secure your farming future.',
    image: FarmEquipment,
    link: '',
  },
  {
    name: 'Micro Loan',
    description:
      'Cultivate a brighter future! We understand the unique needs of rural communities and offer tailored loan solutions to empower your growth. Invest in land, equipment, or livestock with our Rural Loans.',
    image: MicroLoan,
    link: '',
  },
];

export const tierObject: TierObject = {
  platinum: {
    class:
      'rounded bg-gradient-to-r from-zinc-800 via-zinc-600 to-zinc-400 px-2 pb-0.5 pt-1 text-xs font-semibold leading-3 text-white',
    title: 'layoutHeader.platinumTier',
  },
  gold: {
    class:
      'rounded bg-gradient-to-r from-[#FFD325] from-10% via-[#FFF8DA] via-30% to-[#FFD016] px-2 pb-0.5 pt-1 text-xs font-semibold leading-3 text-black',
    title: 'layoutHeader.goldTier',
  },
  silver: {
    class:
      'rounded bg-gradient-to-r from-[#C8C8C8] from-10% via-[#EFEFEF] via-50% to-[#A8A6A6] px-2 pb-0.5 pt-1 text-xs font-semibold leading-3 text-black',
    title: 'layoutHeader.silverTier',
  },
  bronze1: {
    class:
      'rounded bg-gradient-to-r from-[#E69C58] from-10% via-[#EB850C] via-80% to-[#8F602A] px-2 pb-0.5 pt-1 text-xs font-semibold leading-3 text-black',
    title: 'layoutHeader.bronze1Tier',
  },
  bronze2: {
    class:
      'rounded bg-gradient-to-r from-[#E69C58] from-10% via-[#EB850C] via-80% to-[#8F602A] px-2 pb-0.5 pt-1 text-xs font-semibold leading-3 text-black',
    title: 'layoutHeader.bronze2Tier',
  },
};

export const roles = {
  nonVPP: 'Non VPP',
};

export const leadFunnelOptions: FunnelItemType[] = [
  { label: 'Login', value: 'C0', defaultValue: false },
  { label: 'WIP', value: 'C1', defaultValue: false },
  {
    label: 'Non Policy Reject',
    value: 'C2',
    defaultValue: false,
  },
  {
    label: 'Approved and not disbursed',
    value: 'C3',
    defaultValue: false,
  },
  { label: 'Disbursed', value: 'C4', defaultValue: false },
  { label: 'Expired', value: 'Expired', defaultValue: false },
];

export const filterByOptions = {
  createdDate: 'date',
  fieldAgents: 'field-agents',
  leadfunnel: 'lead-funnel',
};

export const customColsDatatable: {
  agreement_no: DatatableColumnProps;
  loan_amount: DatatableColumnProps;
  asset_model: DatatableColumnProps;
  term: DatatableColumnProps;
} = {
  agreement_no: {
    label: 'Agreement No.',
    sortable: false,
  },
  loan_amount: {
    label: 'Loan Amount',
    sortable: true,
  },
  asset_model: {
    label: 'Asset Model',
    sortable: true,
  },
  term: {
    label: 'Term (in yrs)',
    sortable: true,
  },
};

export const reports = {
  login: 'lead',
  disbursal: 'disbursal',
};

export const delqBlocksLimits = {
  first: 1.5,
  second: 2,
  third: 2.5,
  forth: 3,
  fifth: 3.1,
};

export const delqPerBlockPer = 20;

export const rupeeSymbol = '₹';

export const colorBlockRangeArr = ['<1.5%', '<2%', '<2.5%', '<3%', '>3%'];

export const leadLadderInfoArr = [
  { title: 'dashboard.login', description: 'dashboard.loginText' },
  { title: 'dashboard.wip', description: 'dashboard.wipText' },
  { title: 'dashboard.reject', description: 'dashboard.rejectText' },
  { title: 'dashboard.abnd', description: 'dashboard.abndText' },
  { title: 'dashboard.disbursed', description: 'dashboard.disbursedText' },
  { title: 'dashboard.expired', description: 'dashboard.expiredText' },
];
